import { Typography } from "@mui/material";
import React from "react";

const SectionLabel = ({ children, ...props }) => {
  return (
    <Typography fontSize="16px" fontWeight={500} {...props}>
      {children}
    </Typography>
  );
};

export default SectionLabel;
